<template>
	<div class="c-editor">
		<editor-content class="c-editor__textarea" :editor="editor" />
	</div>
</template>

<script>
import { Editor, EditorContent } from 'tiptap';
import {
	Blockquote,
	CodeBlock,
	HardBreak,
	Heading,
	HorizontalRule,
	OrderedList,
	BulletList,
	Placeholder,
	ListItem,
	TodoItem,
	TodoList,
	Bold,
	Code,
	Italic,
	Link,
	Strike,
	Underline,
	History,
} from 'tiptap-extensions';

export default {
	components: {
		EditorContent,
	},
	props: ['note'],
	data: function () {
		var obj = {
			active: false,
			debounceTimeout: 600,
			copyText: 'Copy',
			currentNote: null,
			maxLength: 600,
			editor: new Editor({
				editorProps: {
					handleTextInput: (view) => {
						if (
							view.state.doc.textContent.length >= this.maxLength &&
							view.state.selection.empty
						) {
							return true;
						}
					},
					handlePaste: (view, event, slice) => {
						if (
							view.state.doc.textContent.length + slice.size >
							this.maxLength
						) {
							slice.content = new DocumentFragment();
						}
					},
				},
				editable: true,
				autoFocus: true,
				extensions: [
					new HardBreak(),
					new HorizontalRule(),
					new Bold(),
					new Placeholder({
						emptyEditorClass: 'is-editor-empty',
						emptyNodeClass: 'is-empty',
						emptyNodeText: 'Add a note',
						showOnlyWhenEditable: true,
						showOnlyCurrent: true,
					}),
					new History(),
				],
				onUpdate: (e) => {
					this.comment.raw = e.state.doc.textContent;
					this.comment.json = e.getJSON();
					this.comment.html = e.getHTML();
					this.fn();
				},
				content: '',
			}),
			comment: {
				raw: '',
				json: {},
				html: '',
			},
			fn: null,
		};
		return obj;
	},
	watch: {
		note: {
			handler: function () {
				if (this.note) {
					this.editor.clearContent();
					this.active = true;
					if (this.note && this.note.comment && this.note.comment.json) {
						this.editor.setContent(this.note.comment.json);
					}
				} else {
					this.active = false;
				}
			},
			immediate: true,
		},
	},
	methods: {
		debounce: function (func, wait, immediate) {
			var timeout;
			return function () {
				var context = this,
					args = arguments;
				var later = function () {
					timeout = null;
					if (!immediate) func.apply(context, args);
				};
				var callNow = immediate && !timeout;
				clearTimeout(timeout);
				timeout = setTimeout(later, wait);
				if (callNow) func.apply(context, args);
			};
		},
		updateComment: function () {
			var note = this.note;
			note.comment = this.comment;
			this.$store.dispatch('note/updateNote', note);
			//this.$refs.notification.activate();
		},
	},
	created: function () {
		this.fn = this.debounce(() => {
			this.updateComment();
		}, this.debounceTimeout);
	},
};
</script>

<style lang="scss">
.c-editor {
	&__textarea {
		> div {
			border-radius: var(--border-radius-sm);

			p.is-editor-empty:first-child::before {
				content: attr(data-empty-text);
				float: left;
				opacity: 0.4;
				pointer-events: none;
				height: 0;
				font-style: italic;
			}

			&:focus {
				outline: none;
				@include focus();
			}
		}
	}
}
</style>